import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateLocale'
})
export class DateLocalePipe implements PipeTransform {
  static readonly DATE_FMT: string = 'dd/MM/yyyy';
  static regexYear = /\d{4}/m;

  constructor(private datePipe: DatePipe) {}

  transform(isoDate: string, lang: string): string | null {
    if (!isoDate) {
      return '';
    }

    const dateEn: string = this.datePipe.transform(isoDate, DateLocalePipe.DATE_FMT);
    if (lang === 'th') {
      return this.getDateTH(dateEn);
    }
    return dateEn;
  }

  private getDateTH(dateEn: string): string {
    const yearEn: RegExpExecArray = DateLocalePipe.regexYear.exec(dateEn);
    return dateEn.replace(DateLocalePipe.regexYear, this.getBuddhaYear(yearEn[0]));
  }

  private getBuddhaYear(year: string): string {
    const yearTh: number = parseInt(year, 10) + 543;
    return yearTh.toString();
  }
}
